// extracted by mini-css-extract-plugin
module.exports = {"closed":"UTetiHVZgugozG8EzoDIAw==","opened":"hGA1+EOHbnmHUXPC+favXg=="};